import platform from "../../../util/platform";
const create = (request) => {
    return (params) => {
        const path = `/progress/user/document/create`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, request);
    };
};
const getSignedUploadUrl = (request) => {
    return (params) => {
        const path = `/progress/user/document/upload/signed`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, request);
    };
};
const getSignedDownloadUrl = (request) => {
    return (params) => {
        const path = `/progress/user/document/download/signed`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, request);
    };
};
const downloadSignedDocument = (url) => {
    const reqInit = {
        method: 'GET',
    };
    return fetch(url, reqInit)
        .then((resp) => resp.blob())
        .then((blob) => {
        var _a;
        const fileUrl = window.URL.createObjectURL(blob);
        const alink = document.createElement('a');
        alink.href = fileUrl;
        alink.download = ((_a = url.split('/').pop()) === null || _a === void 0 ? void 0 : _a.split('?')[0]) || 'error.txt';
        alink.click();
    });
};
const uploadSignedDocumentToS3 = (url, file) => {
    const reqInit = {
        method: 'PUT',
        body: file,
    };
    return fetch(url, reqInit);
};
const userDocument = {
    create,
    getSignedUploadUrl,
    getSignedDownloadUrl,
    downloadSignedDocument,
    uploadSignedDocumentToS3
};
export default userDocument;
